<div class="p-fluid">
  <h3>Phone</h3>
  <div class="p-field">
    <label for="phone-number" class="p-text-bold required">Phone Number</label>
    <input id="phone-number" type="text" pInputText
                                          autocorrect="off" 
                                          spellcheck="false" 
                                          autocomplete="off" 
                                          placeholder="A phone number for a user to call."
                                          [ngModel]="feature.value"
                                          (ngModelChange)="updatePhoneNumber($event)"> 
  </div>
</div>